import { useEffect, useState } from 'react'
import { captureException } from '@sentry/react'
import { getLanguage } from '../internal/TextLabels/text'
import { Features, isEnabled } from '../models/features'

export const ModuleFeatures = Object.freeze({
  reconciliationApp: Features.RECONCILIATION,
  paymentManagementApp: Features.PAYMENT_MANAGEMENT,
})

const useModuleMenu = (moduleConfig, userAuthorities, enabledOverride) => {
  const [menuData, setMenuData] = useState(null)

  useEffect(() => {
    if (
      enabledOverride ||
      !ModuleFeatures[moduleConfig.name] ||
      isEnabled(ModuleFeatures[moduleConfig.name])
    ) {
      moduleConfig
        .menu()
        .then(module => {
          const populatedMenuData = module.populateMenu(
            getLanguage(),
            moduleConfig.basePath,
          )
          if (userAuthorities.includes(populatedMenuData?.menu?.authority)) {
            setMenuData(populatedMenuData)
          }
        })
        .catch(exception => {
          captureException(exception, {
            tags: {
              errorType: `ScriptExternalLoadError:${moduleConfig.name}`,
            },
            extra: {
              skipSanitize: true,
            },
          })
          // eslint-disable-next-line no-console
          console.warn(exception)
        })
    }
  }, [userAuthorities])

  return menuData
}

export default useModuleMenu
